import history from '@/history';
import activityMethods from './activity';
import thirdpart from './thirdpart';

type JumpType = 'replace' | 'push' | 'newTab' | 'reload';

function goto(href: string, type: JumpType = 'push') {
  switch (type) {
    case 'replace':
      history.replace(href);
      break;
    case 'push':
      history.push(href);
      break;
    case 'newTab':
      window.open(href, '_blank', 'noopener, noreferrer');
      break;
    case 'reload':
      window.location.reload();
  }

  return href;
}

function toIndex() {
  return '/';
}

function toChannelservice() {
  return '/channel-service';
}
function toPlatformMarketing() {
  return '/platform-marketing';
}

const allMethodsGoToConfig: {
  [key: string]: (...args: any[]) => string;
} = {
  toIndex,
  toChannelservice,
  toPlatformMarketing,
  ...activityMethods,
  ...thirdpart,
};

type TypeGetHref = (...args: any[]) => string;

type HrefObj = { [key in JumpType]: TypeGetHref } & { get: TypeGetHref };

function factoryGoto<T extends { [key: string]: TypeGetHref }>(configGoto: T) {
  // 这里不会有初始化的，后面添加不行吗？
  let innerMethods: {
    [key in keyof T]: (...args: any[]) => HrefObj;
  } = {} as any;

  Object.keys(configGoto).forEach((key: keyof T) => {
    const getHref = configGoto[key];
    // TOFIX: args类型可以被推断出来
    innerMethods[key] = function (...args: any[]): HrefObj {
      const href = getHref(...args);
      return {
        get: () => href,
        push: () => goto(href, 'push'),
        replace: () => goto(href, 'replace'),
        newTab: () => goto(href, 'newTab'),
        reload: () => goto(href, 'reload'),
      };
    };
  });

  return innerMethods;
}

// TOFIX: 还没有使用就将对象生成是否合适？
const allMethodsGoTo: {
  [key: string]: (...args: any[]) => HrefObj;
} = factoryGoto(allMethodsGoToConfig);

export default allMethodsGoTo;

export { goto, factoryGoto };

export type { HrefObj };
